@use '@design/design-tokens/typography/typography' as *;

.secondaryText {
  display: flex;
  align-items: center;
  gap: 4px;
  @include typography-v2-body-xs;
}

.trackingStatus {
  color: var(--text-soft);

  &.isTracking {
    color: var(--viz-bullish);
  }
}

.horizon {
  color: var(--text-soft);
}

.assetNameText {
  @include typography-v2-body-xs;
  color: var(--text-default);

  &.read {
    color: var(--text-soft);
  }

  &.compact {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
  }

}

.secondaryAssetInfoText {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}
